import {
    lazyLoadMyDillardsBar
} from './_lazyLoadMyDillardsBar';
import {
    getCookie
} from '../global/_cookies';
import {
    isInternational
} from '../global/_checkForInternational';
import {
    getCaptchaSecurityCode
} from '../global/_getCaptchaSecurityCode';
import {
    toggleMyDillards
} from './_toggleMyDillards';

import Cookies from 'js-cookie'
var miniCartCookie = Cookies.get('301_CVMINICART');
export const toolbarInit = () => {
    var touchDevice = $('html.touch').length,
        myDillardsShow = $('.myDillardsShow'),
        myDillardsShoppingBag = $('.myDillardsShoppingBag'),
        miniShoppingCart = $('#miniShoppingCart'),
        myDillardsDropDown = $('#myDillardsDropDown'),
        myDillardsMenu = $('#my-dillards-menu'),
        welcomeMessage = $('#welcome-message'),
        dropdownDelay = null,
        closeMyDillards = null;
    //No-Touch Devices
    if (!touchDevice) {
        //Remove HREF from Login
        //$('#myDillardsLoginLink').attr('href', 'javascript:void(0);');
        //Open myDillards Dropdown on Click
        // if ($('#myDillardsLoginLink:visible').length == 0) {
        //     myDillardsShow.on('click', function (event) {
        //         if ($('.wish-list-page').length > 0 || $('#layoutCart').length > 0) {
        //             if ($('html').hasClass('no-localstorage')) {
        //                 Cookies.set("wishCart", true, {
        //                     path: '/',
        //                     domain: false
        //                 });
        //             } else localStorage.setItem("wishCart", true);
        //         }
        //         clearTimeout(dropdownDelay);
        //         lazyLoadMyDillardsBar();
        //         //Set the Appropriate Arrows to Show
        //         var clicked = $(this);
        //         var hideMyDillards = () => {
        //             ($('html').hasClass('no-localstorage')) ? Cookies.remove('wishCart'): localStorage.removeItem('wishCart');
        //             $(welcomeMessage).removeClass('loginArrow');
        //             $(myDillardsMenu).removeClass('myDillardsArrow');
        //             myDillardsDropDown.removeClass('visible');
        //         };
        //         if ((clicked.attr('id') == "myDillardsLoginLink")) {
        //             $(welcomeMessage).toggleClass('loginArrow');
        //             $(myDillardsMenu).removeClass('myDillardsArrow');
        //         } else {
        //             $(myDillardsMenu).toggleClass('myDillardsArrow');
        //             $(welcomeMessage).removeClass('loginArrow');
        //         }
        //         //Toggle My Dillards Dropdown
        //         toggleMyDillards(miniShoppingCart, myDillardsShoppingBag, dropdownDelay, myDillardsDropDown);
        //         //Click Outside of MyDillards Dropdown to Close MyDillards
        //         $('html, #topbar-wrapper, .container, #footer').on('click', function (event) {
        //             hideMyDillards();
        //             myDillardsDropDown.fadeOut('fast');
        //         });
        //         //Click to close myDillards Dropdown
        //         if ($('#myDillardsDropDown.visible').length > 0) {
        //             $('.closeMyDillards').click(function () {
        //                 hideMyDillards();
        //                 $(this).parent().hide();
        //                 return false;
        //             });
        //         }
        //         //Keep myDillardsDropdown open
        //         $('#myDillardsDropDown').on('click', function (event) {
        //             if (!$(event.target).is('[data-toggle="modal"]')) event.stopPropagation();
        //         });
        //         return false;
        //     }).mouseenter(function () {
        //         clearTimeout(closeMyDillards);
        //         clearTimeout(shoppingbagMiniCartFadeInDelay);;
        //         //Set Login Captcha
        //         if ($('.captchaDiv img').length == 0) {
        //             (!getCookie('capver')) ? getCaptchaSecurityCode('I'): $(".captchaContainer").hide();
        //         }
        //     });
        // }
        //Shopping Bag and MiniCart Varibles
        var shoppingbagMiniCartFadeInDelay = null,
            shoppingbagMiniCartFadeOutDelay = null,
            miniCartFadeOutDelay = null,
            cartDelivered = false,
            cartReady = false;
        //CheckAjaxDeliverd Function
        var checkAjaxDeliverd = function () {
            //Check if Ajax Call Commplete
            $(document).ajaxComplete(function (event, xhr, settings) {
                if (settings.url === "/webapp/wcs/stores/servlet/MiniCartPopoutCmd") {
                    cartDelivered = true;
                    initMiniCart();
                }
            });
        };
        // Initialize MiniCart
        var initMiniCart = function () {
            //Check if cart needs to be called
            if (cartDelivered) {
                if ($("#miniShoppingCart").children().length > 0) {
                    cartReady = true;
                    openMiniCart();
                }
            } else {
                checkAjaxDeliverd();
            }
        };
        //Check if Cart Good to Open
        var openMiniCart = function () {
            //Set MiniCart Delay
            shoppingbagMiniCartFadeInDelay = setTimeout(function () {
                if (cartReady) {
                    clearTimeout(shoppingbagMiniCartFadeOutDelay);
                    clearTimeout(miniCartFadeOutDelay);
                    miniShoppingCart.fadeIn('fast');
                    myDillardsShoppingBag.addClass('shoppingCartArrow');
                    miniShoppingCart.addClass('visible');
                } else {
                    //Cart Not Ready Call initMiniCart
                    clearTimeout(shoppingbagMiniCartFadeInDelay);
                    initMiniCart();
                }
            }, 300);
        };
        var getMinCartReady = function () {
            //Check if myDillards Dropdown is Closed and fire MiniCart
            if (!$('#myDillardsDropDown').hasClass('visible')) openMiniCart();
            else {
                closeMyDillards = setTimeout(function () {
                    //Close My Dilliards Dropdown
                    // hideMyDillards();
                    // myDillardsDropDown.hide();
                    getMinCartReady();
                }, 500);
            }
        };
        //Open MiniCart Dropdown on shopping bag hover
        myDillardsShoppingBag.mouseenter(function () {
            //Check if User is not International
            if (!isInternational()) getMinCartReady();
        }).mouseleave(function (event) {
            clearTimeout(shoppingbagMiniCartFadeInDelay);
            clearTimeout(closeMyDillards);
            //Set MiniCart Delay
            shoppingbagMiniCartFadeOutDelay = setTimeout(function () {
                miniShoppingCart.hide();
                myDillardsShoppingBag.removeClass('shoppingCartArrow');
                miniShoppingCart.removeClass('visible');
                cartDelivered = false;
                cartReady = false;
            }, 750);
        });
        //Minicart Remain Open on Hover
        miniShoppingCart.mouseenter(function () {
            clearTimeout(shoppingbagMiniCartFadeOutDelay);
            clearTimeout(miniCartFadeOutDelay);
            //Delegate clicks to close empty bag on X and continue shopping
            $('#emptyBag').on('click','#emptyBagClose, .myDillardsShoppingBagLink', function() {
              $('#miniShoppingCart').css({'display':'none'});
              $('.myDillardsShoppingBag ').removeClass('shoppingCartArrow');
            });

        }).mouseleave(function (event) {
            miniCartFadeOutDelay = setTimeout(function () {
                miniShoppingCart.fadeOut('fast');
                myDillardsShoppingBag.removeClass('shoppingCartArrow');
                miniShoppingCart.removeClass('visible');
                cartDelivered = false;
                cartReady = false;
            }, 750);
        });
    }
    //Touch Enabled Devices
    if (touchDevice) {
        //STOP PROPAGATION
        $('myDillardsDropDown, myDillardsShow, myDillardsShoppingBag').click(function (event) {
            event.stopPropagation();
            return false;
        });
    }

};
